import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { getCookie, setCookie } from "../../utilities/cookieHelper";
import i18n from "@/i18n";
import { AuthStore } from "../../store/modules/auth";
import { DiTokens } from "../../services/diTokens";
import IAuthService from "../../services/auth/IAuthService";
import { container } from "@/inversify.config";
import { BaseLoginModel } from "../../models/auth/BaseLoginModel";

export class SettingsVue extends Vue {
  /**Стор авторизации */
  get authService(): IAuthService<BaseLoginModel> {
    return container.get<IAuthService<BaseLoginModel>>(DiTokens.AuthService);
  }
  /**Стор авторизации */
  get authStore(): AuthStore {
    return getModule(AuthStore, this.$store);
  }

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Стор настроек */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get personLoading(): boolean {
    return this.personStore.loading;
  }

  get configLoading(): boolean {
    return this.configStore.loading;
  }

  get showHiddenItemsVisibility() {
    return this.configStore.isHiddenItemsVissible;
  }

  get showClosedItemsVisibility() {
    return this.configStore.isClosedItemsVissible;
  }
  get showRestHiddensVisibility() {
    return this.configStore.isRestHiddenVissible;
  }

  get personInfo(): any {
    return this.personStore.personInfo;
  }

  get apiData(): any {
    return this.configStore.apiData;
  }

  showHiddenItems: boolean = this.showHiddenItemsVisibility;

  showClosedItems: boolean = this.showClosedItemsVisibility;

  showRestHiddens: boolean = this.showRestHiddensVisibility;

  localeValue: boolean = getCookie("localeValue") === "en" ? true : false;

  operationsList: Record<string, string> = {
    aliasEdit: "AliasEditModal",
    passwordEdit: "PasswordEditModal",
    sbpDefault: "SbpDefaultModal",
    esiaRegistration: "EsiaRegistrationModal",
    sbpEnable: "SbpEnableModal",
    accountInDefault: "AccountInDefaultModal",
    setDefaultOutAccount: "DefaultOutAccount",
    selectBanks: "BankSelectModal",
    downloadTemplates: "DownloadTemplatesModal"
  };

  activeOperation: string = "";

  modalShow: boolean = false;

  get actions(): Array<any> {
    const actions: Array<any> = [];
    actions.push({
      /** Смена пароля */
      text: i18n.t("main.settings.changePassword"),
      iconClass: "change-pass-icon",
      action: () => {
        this.openDialog(this.operationsList.passwordEdit);
      }
    });
    actions.push({
      /**Действие оплаты со счета */
      text: i18n.t("main.settings.editAlias"),
      iconClass: "edit-login-icon",
      action: () => {
        this.openDialog(this.operationsList.aliasEdit);
      }
    });
    actions.push({
      /**Действие оплаты со счета */
      text: i18n.t("main.settings.logout"),
      iconClass: "logout-icon",
      action: async () => {
        await this.logout();
      }
    });
    return actions;
  }

  /**Выход из системы */
  async logout() {
    await this.authService.logout();
  }

  setShowRestHiddens() {
    this.configStore.setShowRestVisibility(this.showRestHiddens);
  }
  setShowHiddenItems() {
    this.configStore.setItemsVisibility(this.showHiddenItems);
    this.configStore.setClosedItemsVisibility(this.showHiddenItems)
  }

  setShowClosedItems() {
    this.configStore.setClosedItemsVisibility(this.showClosedItems);
  }

  setLocaleValue() {
    const locale = this.localeValue ? "en" : "ru";
    setCookie("localeValue", locale);
    this.$root.$i18n.locale = locale;
    this.$root.$i18n.fallbackLocale = locale;
  }

  openDialog(key: string) {
    this.activeOperation = key;
    this.modalShow = true;
  }

  /** Открытие информации о ебс */
  openAnotherSite(e, link: string) {
    e.preventDefault();
    window.open(this.$options.filters.url(link), "_blank");
  }
}
